import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type AccordionOpenItemsState = {
    openItems: Record<string, string[]>;
};

const initialState: AccordionOpenItemsState = {
    openItems: {},
};

const accordionOpenItemsSlice = createSlice({
    name: 'accordionOpenItems',
    initialState,
    reducers: {
        setOpenItems(state, action: PayloadAction<{ contractId: string; items: string[] }>) {
            state.openItems[action.payload.contractId] = action.payload.items;
        },
        addOpenItem(state, action: PayloadAction<{ contractId: string; item: string }>) {
            const { contractId, item } = action.payload;
            if (!state.openItems[contractId]) {
                state.openItems[contractId] = [];
            }
            if (!state.openItems[contractId].includes(item)) {
                state.openItems[contractId].push(item);
            }
        },
    },
});

export const accordionOpenItemsReducer = accordionOpenItemsSlice.reducer;
export const accordionOpenItemsActions = accordionOpenItemsSlice.actions;
